
import Vue from 'vue'

// Definicja typu dla jasności (możesz przenieść do osobnego pliku)
interface Member {
  name: string;
  image: any;
  contact: string;
  content: string;
}

export default Vue.extend({
  name: 'HomeMeetOurTeam',
  data() {
    return {
      members: [] as Member[]
    }
  },
  mounted() {
    this.fetchMembers();
  },
  methods: {
    async fetchMembers() {
      try {
        const response = await this.$api.get('/contents/meet-our-team');
        this.members = response.data.members;
      } catch (error) {
        console.error("Błąd podczas pobierania zespołu:", error);
      }
    }
  }
})
